import { useQuery, useMutation } from '@tanstack/react-query'

import type { UseQueryResult, UseMutationResult } from '@tanstack/react-query'
import type { AxiosRequestConfig } from 'axios'
import type { IReplyReviewMacro, IReviewReplyMacroPayload } from '~/types/review'

import {
  createReviewReplyMacro,
  deleteReviewReplyMacro,
  getReviewsReplyMacro,
  getReviewsReplyMacroNames,
  updateReviewReplyMacro,
} from '~/api/reviews'

////////// KEYS //////////

export const keys = {
  all: ['reviews-reply-macros'] as const,
  list: (params?: AxiosRequestConfig['params']) => [...keys.all, 'listing', params] as const,
  replyMacrosNames: () => [...keys.all, 'names'] as const,
}

////////// QUERIES //////////

export const useReviewsReplyMacrosQuery = (
  params?: AxiosRequestConfig['params']
): UseQueryResult<IReplyReviewMacro[]> => {
  return useQuery({
    queryFn: () => getReviewsReplyMacro(params),
    queryKey: keys.list(params),
  })
}

export const useReviewsReplyMacrosNamesQuery = (): UseQueryResult<string[]> => {
  return useQuery({
    queryFn: getReviewsReplyMacroNames,
    queryKey: keys.replyMacrosNames(),
  })
}

////////MUTATIONS //////////

export const useCreateReviewReplyMacroMutation = (): UseMutationResult<
  IReplyReviewMacro,
  unknown,
  IReviewReplyMacroPayload,
  unknown
> => {
  return useMutation({ mutationFn: createReviewReplyMacro })
}

export const useDeleteReviewReplyMacroMutation = (): UseMutationResult<void, unknown, { macroId: string }, unknown> => {
  return useMutation({ mutationFn: deleteReviewReplyMacro })
}

export const useUpdateReviewReplyMacroMutation = (): UseMutationResult<
  IReplyReviewMacro,
  unknown,
  { macroId: string; payload: IReviewReplyMacroPayload },
  unknown
> => {
  return useMutation({ mutationFn: updateReviewReplyMacro })
}
